<div class="modal-header" *ngIf="showAsDialog" ngxModalDraggable>
    <h4 class="modal-title">Order Detail</h4>
</div>
<div class="modal-body p-0 flex-fill d-flex flex-column compact-form" *ngIf="!!projection">
    <div class="card">
        <div class="card-body pb-3">
            <div class="btn-toolbar mx-0 mb-0 mt-0">
                <div>
                    <button *ngIf="hasChanges() && !showAsDialog" class="btn btn-sm btn-primary me-2" (click)="save()">Save</button>
                    <button *ngIf="hasChanges() && !showAsDialog" class="btn btn-sm btn-success me-4" (click)="cancel()">Cancel</button>
                    <button *ngIf="!hasChanges() && !showAsDialog" class="btn btn-sm btn-primary me-4" (click)="close()">Close</button>
                    <button *ngIf="!hasChanges() && !showAsDialog" class="btn btn-sm btn-primary ms-4" (click)="submit()">Submit Inventory Projections</button>
                    <dx-check-box *ngIf="!hasChanges() && !showAsDialog" class="ms-2 align-middle" [(value)]="includeAssemblyParts" text="Include Assembly Parts"></dx-check-box>
                </div>
            </div>

            <dx-form class="p-2" [formData]="projection" [colCount]="1" validationGroup="mainValidationGroup">
                <dxi-item itemType="group" [colSpan]="1" [colCount]="1">
                    <dxi-item dataField="number" [label]="{ text: 'Projection #' }" [editorOptions]="{ disabled: true, width: '150px' }"> </dxi-item>
                    <!-- <dxi-item dataField="createdBy" [label]="{ text: 'Created By' }" [editorOptions]="{ disabled: true }"> </dxi-item> -->
                    <dxi-item dataField="created" [label]="{ text: 'Date' }" [editorOptions]="{ width: '150px' }"> </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [colSpan]="3">
                    <dxi-item [label]="{ text: 'Notes' }">
                        <div *dxTemplate>
                            <dx-text-area [(value)]="projection.notes" [height]="100"></dx-text-area>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>

    <div class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '400px' : '100%' }">
        <dx-data-grid
            #linesGrid
            height="200"
            keyExpr="id"
            [dataSource]="lines"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="onSelectionChange($event)"
            (onRowUpdated)="onRowUpdating($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
            class="lines-grid"
            [sorting]="'none'"
        >
            <dxi-column dataField="lineNumber" [visible]="false" width="100" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
            <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="!readOnly" width="65"></dxi-column>
            <dxi-column dataField="partNumber" caption="Part #" [allowEditing]="false" width="200" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="description" caption="Description" [allowEditing]="false" width="400"></dxi-column>
            <dxi-column dataField="builtBy" caption="Built By" [allowEditing]="true" width="200"></dxi-column>
            <dxi-column dataField="notes" caption="Note" width="150" [allowEditing]="true"></dxi-column>
            <dxi-column></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <div class="parent-part-number" *ngIf="cell.data.partId && !cell.data.parentLineId && !cell.data.isReplacement">{{ cell.text }}</div>
                <div class="replacement-part-number" *ngIf="cell.data.isReplacement">{{ cell.text }}</div>
                <div class="misc-part-number" *ngIf="!cell.data.partId && !cell.data.isReplacement">{{ cell.text }}</div>
                <div class="option-part-number" *ngIf="cell.data.parentLineId">{{ cell.text }}</div>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button accesskey="t" class="btn btn-sm btn-secondary me-2" (click)="addLines()" [disabled]="readOnly">Add Part(s)</button>
                <button class="btn btn-sm btn-secondary me-2" (click)="removeLine()" [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length === 0">Remove</button>

                <button
                    class="btn btn-sm btn-success me-2"
                    (click)="updateLineQuantity()"
                    [hidden]="showAsDialog && !isInvoiceCreditSalesOrder"
                    [disabled]="
                        linesGrid.instance.getSelectedRowsData().length !== 1 ||
                        linesGrid.instance.getSelectedRowsData()[0].parentLineId !== null ||
                        linesGrid.instance.getSelectedRowsData()[0].submitted
                    "
                >
                    Update Qty
                </button>
            </div>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-editing [mode]="'cell'" [allowUpdating]="!readOnly && !showAsDialog"></dxo-editing>
            <dxo-state-storing [enabled]="true" [storageKey]="'inventory-projection-detail-grid'"></dxo-state-storing>
        </dx-data-grid>
    </div>
</div>
<div class="modal-footer" *ngIf="showAsDialog">
    <button class="btn btn-success ms-1" (click)="closeDialog()">Close</button>
</div>
